module.exports = __webpack_public_path__ + "assets/img/thumb-Logitech-G-Landing-page.83028ec3.jpg";